export default "__VITE_ASSET__pRytYU9C__"